import AudioListen from "@/components/AudioListen";

const PREVIEW_BOOKS = [
  { id: "book-01", title: "T.A.C.C. Work Book", preview: "Preview. From the T.A.C.C. Work Book — Through Adversity Comes Change. By Rich Culmer. You don't go around it. You go through it. And through is where the change happens. The T.A.C.C. Promise. I will not go around the struggle. I will not numb it, blame it, or waste it. I will go through it. Part One. Personal Growth and Identity. Struggle One. Letting go of who you used to be. The question — sit with it first. What part of your past are you still holding onto that is keeping you small? Why you must go through this struggle. Your old identity cannot fit the new level. You cannot grow into who you are becoming while clinging to who you were. Where it gets you. You finally become who you were meant to be — without apology. The struggle is not the enemy of blessing. It is the delivery system. There is always a new through." },
  { id: "book-02", title: "T.A.C.C. Manual — Guide to Healing", preview: "Preview. From the T.A.C.C. Manual — Guide to Healing. Part One. God. The Root of All Change. Before the modules. Before the audit. Before the breath. There is a reckoning most of us are too busy to name. Whether you call it God, higher power, source, or the still voice underneath all the noise — every honest change begins there. You cannot heal what you do not first surrender. You cannot rebuild what you do not first hand over. This part of the manual is not doctrine. It is an invitation. Everything that follows — the five principles, the three articles, and the one healer — depends on this one decision. To stop pretending you are the source of the change. And to become the one who receives it." },
];

const PAGE_LINKS = [
  { to: "/", label: "Home" },
  { to: "/modules", label: "Modules page" },
  { to: "/books", label: "Books page" },
  { to: "/peer-plus", label: "Peer Plus" },
  { to: "/manifesto", label: "Manifesto" },
  { to: "/about", label: "What We Do" },
  { to: "/shop", label: "Shop" },
  { to: "/b2b", label: "For Companies" },
];

export const BookPreviews = () => (
  <div>
    <div className="section-tag mb-4">§ Books · Kindle previews</div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {PREVIEW_BOOKS.map((b) => (
        <div key={b.id} className="tacc-card p-6" data-testid={`content-book-${b.id}`}>
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#78716C] mb-2">{b.id}</div>
          <h4 className="font-display text-xl md:text-2xl tracking-tight mb-3">{b.title}</h4>
          <p className="text-[#78716C] text-sm leading-relaxed mb-4 line-clamp-3">{b.preview}</p>
          <AudioListen text={b.preview} label="Play the preview" testid={`content-listen-${b.id}`} />
        </div>
      ))}
    </div>
  </div>
);

export const ContentLinks = () => (
  <div className="tacc-card p-6 md:p-8" data-testid="content-links">
    <div className="section-tag mb-4">§ Live page shortcuts</div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {PAGE_LINKS.map((l) => (
        <a key={l.to} href={l.to} target="_blank" rel="noreferrer" className="btn-outline text-xs justify-center" data-testid={`content-link-${l.to.replace(/\//g, "_") || "home"}`}>
          {l.label} →
        </a>
      ))}
    </div>
  </div>
);
